module.exports = __webpack_public_path__ + "img/17848_S.bae3f22d.png";